<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Message</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">Message</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="main-content-label mb-1">Message</h6>
              <div>
                <p class="font-weight-bold">{{formData.date}}</p>
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Name:</p>
                <p>{{formData.name}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Email:</p>
                <p>{{formData.email}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Phone:</p>
                <p>{{formData.phone}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Message:</p>
                <p>{{formData.message}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddNews',
  data () {
    return {
      formData: {}
    }
  },
  created () {
    this.getMessageData(this.$route.params.id).then(res => {
      console.log(res.data)
      this.formData = { ...res.data }
    })
  },
  methods: {
    ...mapActions({
      getMessageData: 'support/getMessageData'
    })
  }
}
</script>
